import { Asso_StatutCommande_Commande } from "./Asso_StatutCommande_Commande";

export class StatutCommande {
    id: number = 0;
    nom: string     = "";
    asso_StatutCommande_Commande: Asso_StatutCommande_Commande[] = new Array();
}